module.exports = __webpack_public_path__ + "static/img/A69.1b5b36f2.jpg";